import React from 'react';
import { Login } from '../components/Login/login';

export const LoginPage = () => {
  return (
    <>
      <Login />
    </>
  );
};
